import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Skeleton } from 'antd';
import cn from 'classnames';
import _ from 'lodash';

import { status } from '../../shared/status';
import { TimeFormat } from '../../shared/TimeFormat';
import { BoardData } from '../Board/Board';
import { Tag } from '../Board/Tag';

import cls from './List.module.scss';

interface IList {
    data: BoardData[];
    loading?: boolean;
    onOpen?: (id: string) => void;
}

export const List = ({ loading, data, onOpen }: IList) => {

    const {t} = useTranslation();

    const onCardOpen = (id: string) => {
        if (onOpen) {
            onOpen(id);
        }
    };

    return (
            <div className={cls.list}>
                <div className={cls.header}>
                    <div className={cls.cell}>{t('ID')}</div>
                    <div className={cls.cell}>{t('Date')}</div>
                    <div className={cls.cell}>{t('Task name')}</div>
                    <div className={cls.cell}>{t('Status')}</div>
                    <div className={cls.cell}>{t('Client')}</div>
                    <div className={cls.cell}>{t('Team')}</div>
                    <div className={cls.cell}>{t('Group')}</div>
                    <div className={cls.cell}>{t('Deadline')}</div>
                    <div className={cls.cell}>{t('Reports')}</div>
                </div>
                {loading && <Skeleton active />}
                {_.map(data, task => (
                    <div className={cls.row} key={task.id} onClick={() => onCardOpen(task.id)}>
                        <div className={cls.cell}>
                            {
                                task.id
                            }
                        </div>
                        <div className={cls.cell}>
                            {
                                task.createdAt?.format('DD.MM.YYYY')
                            }
                        </div>
                        <div className={cn([cls.cell, 'bold'])}>
                            {
                                task.name
                            }
                        </div>
                        <div className={cls.cell}>
                            <div className={cls.space}>
                                <Badge color={_.filter(status, item => item.name === task.status)[0].bgColor!}/>
                                {t(task.status)}
                            </div>
                        </div>
                        <div className={cls.cell}>
                            {
                                task.client && <Tag big data={task.client} />
                            }
                        </div>
                        <div className={cls.cell}>
                            <div className={cls.space}>
                                {
                                    _.map(task.users, (user, index) => (<Tag big key={index} data={user} />))
                                }
                            </div>
                        </div>
                        <div className={cls.cell}>
                            {
                                task.group && <Tag big data={task.group} />
                            }
                        </div>
                        <div className={cls.cell}>
                            {
                                task.deadline && <Tag big data={{ id: 'deadline', name: task.deadline.format('DD.MM.YYYY'), color: '#333333' }} />
                            }
                        </div>
                        <div className={cls.cell}>
                            {
                                task.reportsMinutes > 0 && TimeFormat(task.reportsMinutes)
                            }
                        </div>
                    </div>
                ))}
            </div>
    );
};
